import { Component } from '@angular/core';
import { RouterOutlet, RouterLink } from '@angular/router';
import { AuthService } from './core/auth.service';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, NgIf],
  template: `
    <nav *ngIf="auth.token" class="navbar app-navbar sticky-top">
      <div class="container-fluid px-3 px-lg-4">

        <a
          class="navbar-brand fw-bold d-flex align-items-center gap-2"
          [routerLink]="dashboardLink">
          <span class="brand-mark">CPA</span>
          <span class="brand-text">Career Plan Academy</span>
        </a>

        <div class="ms-auto d-flex align-items-center gap-2">


          <div class="dropdown">
            <button
              class="user-menu-btn"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              <div class="user-avatar">
                {{ firstLetter }}
              </div>

              <div class="user-meta d-none d-sm-block text-start">
                <div class="user-name">{{ auth.user()?.name || 'User' }}</div>
                             </div>

              <i class="bi bi-chevron-down small d-none d-sm-inline"></i>
            </button>

            <ul class="dropdown-menu dropdown-menu-end profile-dropdown shadow-lg border-0">
              <li class="px-3 py-3">
                <div class="d-flex align-items-center gap-3">
                  <div class="dropdown-avatar">
                    {{ firstLetter }}
                  </div>

                  <div class="min-w-0">
                    <div class="fw-bold text-dark text-truncate">
                      {{ auth.user()?.name || 'User' }}
                    </div>
                    <small class="text-muted text-truncate d-block">
                      {{ auth.user()?.email || panelName }}
                    </small>
                  </div>
                </div>
              </li>

              <li>
                <hr class="dropdown-divider my-1">
              </li>

              <li>
                <a class="dropdown-item d-flex align-items-center gap-2 py-2" [routerLink]="dashboardLink">
                  <i class="bi bi-grid"></i>
                  <span>Dashboard</span>
                </a>
              </li>

              <li *ngIf="auth.user()?.role === 'student'">
                <a class="dropdown-item d-flex align-items-center gap-2 py-2" routerLink="/student/classes">
                  <i class="bi bi-camera-video"></i>
                  <span>My Classes</span>
                </a>
              </li>

              <li *ngIf="auth.user()?.role === 'student'">
                <a class="dropdown-item d-flex align-items-center gap-2 py-2" routerLink="/student/certificates">
                  <i class="bi bi-award"></i>
                  <span>Certificates</span>
                </a>
              </li>

              <li *ngIf="auth.user()?.role === 'admin'">
                <a class="dropdown-item d-flex align-items-center gap-2 py-2" routerLink="/admin/payments">
                  <i class="bi bi-credit-card"></i>
                  <span>Payments</span>
                </a>
              </li>

              <li>
                <hr class="dropdown-divider my-1">
              </li>

              <li class="px-2 pb-2">
                <button class="logout-dropdown-btn" type="button" (click)="logout()">
                  <i class="bi bi-box-arrow-right"></i>
                  <span>Logout</span>
                </button>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </nav>

    <router-outlet />
  `,
  styles: [`
    .app-navbar {
      min-height: 68px;
      background: linear-gradient(135deg, #0d6efd, #063a91);
      box-shadow: 0 8px 24px rgba(13, 110, 253, .22);
      z-index: 1050;
    }

    .navbar-brand {
      color: #ffffff;
      text-decoration: none;
    }

    .navbar-brand:hover {
      color: #ffffff;
    }

    .brand-mark {
      width: 38px;
      height: 38px;
      border-radius: 13px;
      background: rgba(255, 255, 255, .18);
      color: #ffffff;
      display: grid;
      place-items: center;
      font-size: 12px;
      font-weight: 900;
      letter-spacing: .5px;
    }

    .brand-text {
      color: #ffffff;
      letter-spacing: -.2px;
    }

    .quick-link {
      align-items: center;
      text-decoration: none;
      color: #ffffff;
      background: rgba(255, 255, 255, .14);
      border: 1px solid rgba(255, 255, 255, .16);
      padding: 9px 14px;
      border-radius: 999px;
      font-size: 13px;
      font-weight: 700;
      transition: .2s ease;
    }

    .quick-link:hover {
      background: rgba(255, 255, 255, .22);
      color: #ffffff;
    }

    .user-menu-btn {
      border: 1px solid rgba(255, 255, 255, .18);
      background: rgba(255, 255, 255, .14);
      color: #ffffff;
      border-radius: 999px;
      padding: 6px 10px 6px 6px;
      display: flex;
      align-items: center;
      gap: 10px;
      transition: .2s ease;
    }

    .user-menu-btn:hover,
    .user-menu-btn:focus {
      background: rgba(255, 255, 255, .22);
      outline: none;
    }

    .user-avatar,
    .dropdown-avatar {
      border-radius: 50%;
      display: grid;
      place-items: center;
      font-weight: 900;
      flex: 0 0 auto;
    }

    .user-avatar {
      width: 38px;
      height: 38px;
      background: #ffffff;
      color: #0d6efd;
    }

    .dropdown-avatar {
      width: 48px;
      height: 48px;
      background: #eef5ff;
      color: #0d6efd;
      font-size: 18px;
    }

    .user-name {
      font-size: 13px;
      font-weight: 800;
      line-height: 1.1;
      max-width: 140px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .user-role {
      text-transform: capitalize;
      color: rgba(255, 255, 255, .82);
      font-size: 11px;
      line-height: 1.1;
    }

    .profile-dropdown {
      width: 300px;
      border-radius: 20px;
      padding: 8px;
      margin-top: 10px;
    }

    .dropdown-item {
      border-radius: 12px;
      font-weight: 600;
      color: #334155;
    }

    .dropdown-item i {
      width: 20px;
      color: #0d6efd;
    }

    .dropdown-item:hover {
      background: #eef5ff;
      color: #0d6efd;
    }

    .logout-dropdown-btn {
      width: 100%;
      border: 0;
      background: #fff1f1;
      color: #dc3545;
      border-radius: 14px;
      padding: 11px 14px;
      font-weight: 800;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 9px;
    }

    .logout-dropdown-btn:hover {
      background: #ffe2e2;
    }

    .min-w-0 {
      min-width: 0;
    }

    @media (max-width: 576px) {
      .app-navbar {
        min-height: 62px;
      }

      .brand-text {
        display: none;
      }

      .profile-dropdown {
        width: 280px;
      }

      .user-menu-btn {
        padding: 5px;
      }
    }
  `]
})
export class AppComponent {
  constructor(public auth: AuthService) {}

  get firstLetter() {
    return this.auth.user()?.name?.charAt(0)?.toUpperCase() || 'U';
  }

  get dashboardLink() {
    return this.auth.user()?.role === 'admin' ? '/admin' : '/student';
  }

  get panelName() {
    return this.auth.user()?.role === 'admin' ? 'Control Panel' : 'Student Portal';
  }

  logout() {
    this.auth.logout();
  }
}